<h1 mat-dialog-title>Email Preview</h1>
<div mat-dialog-conent>
  <div [innerHtml]="entryData.html | safeHtml"></div>
</div>
<div mat-dialog-actions>
  <button mat-flat-button mat-dialog-close color="primary">Close</button>
</div>